import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
  Tabs,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import { RowHelper } from "util/TableHelper";
import TransactionProjectTypeListFilter from "../Filters/TransactionProjectTypeListFilter";
import TransactionProjectTypeAddForm from "../Forms/TransactionProjectTypeAddForm";
import SpecialActionCodeAddForm from "../Forms/SpecialActionCodeAddForm";
import TransactionProjectTypeUpdateForm from "../Forms/TransactionProjectTypeUpdateForm";
import TransactionCostCenterAddForm from "../Forms/TransactionCostCenterAddForm";
import TransactionResponsibilityCenterAddForm from "../Forms/TransactionResponsibilityCenterAddForm";

const TransactionProjectTypeList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "Aktarım Parametreleri",
  });
  const [transactionProjectTypes, setTransactionProjectTypes] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [
    addFormSpecialActionCodeVisibility,
    setAddFormSpecialActionCodeVisibility,
  ] = useState(false);

  const [addFormCostCenterVisibility, setAddFormCostCenterVisibility] =
    useState(false);
  const [
    addFormResponsibilityCenterVisibility,
    setAddFormResponsibilityCenterVisibility,
  ] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [
    updateFormSpecialActionCodeVisibility,
    setUpdateFormSpecialActionCodeVisibility,
  ] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [activeTabKey, setActiveTabKey] = useState("1");

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions, activeTabKey]);

  const getTableData = () => {
    setTransactionProjectTypes({
      ...transactionProjectTypes,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];

    if (activeTabKey === "1") {
      conditions.push("ProjectType eq 0");
    } else if (activeTabKey === "2") {
      conditions.push("ProjectType eq 1");
    } else if (activeTabKey === "3") {
      conditions.push("ProjectType eq 2");
    } else if (activeTabKey === "4") {
      conditions.push("ProjectType eq 3");
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/TransactionProjectType?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTransactionProjectTypes({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const onAddTransactionProjectTypesuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onAddSpecialActionCodeSuccess = () => {
    getTableData();
    setAddFormSpecialActionCodeVisibility(false);
  };

  const onAddCostCenterSuccess = () => {
    getTableData();
    setAddFormCostCenterVisibility(false);
  };

  const onAddResponsibilityCenterSuccess = () => {
    getTableData();
    setAddFormResponsibilityCenterVisibility(false);
  };
  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/TransactionProjectType/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const onUpdateTransactionProjectTypesuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: `Pasif olan ${
        activeTabKey === "1"
          ? "projeler"
          : activeTabKey === "2"
          ? "özel hareket kodları"
          : "masraf merkezleri"
      } güncellenemez.`,
    });
  };

  const columns = [
    {
      title: "Proje Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        transactionProjectTypes.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const specialActionCodeColumn = [
    {
      title: "Özel Hareket Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Özel Hareket Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        transactionProjectTypes.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const costCenterColumn = [
    {
      title: "Masraf Merkezi Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Masraf Merkezi Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        transactionProjectTypes.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const responsibilityCenterColumn = [
    {
      title: "Sorumluluk Merkezi Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Sorumluluk Merkezi Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        transactionProjectTypes.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const handleTabChange = (key) => {
    setActiveTabKey(key);
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTransactionProjectTypes(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/TransactionProjectType/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>

        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              activeTabKey === "1"
                ? setAddFormVisibility(true)
                : activeTabKey === "2"
                ? setAddFormSpecialActionCodeVisibility(true)
                : activeTabKey == "3"
                ? setAddFormCostCenterVisibility(true)
                : setAddFormResponsibilityCenterVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined />{" "}
            {activeTabKey === "1"
              ? "Proje Ekle"
              : activeTabKey === "2"
              ? "Özel Hareket Ekle"
              : activeTabKey === "3"
              ? "Masraf Merkezi Ekle"
              : "Sorumluluk Merkezi Ekle"}
          </Button>
        </Col>

        {/* {activeTabKey === "1" ? (
          <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                setAddFormVisibility(true);
              }}
              style={{ marginBottom: 0 }}
            >
              <PlusOutlined /> Proje Ekle
            </Button>
          </Col>
        ) : (
          <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                setAddFormSpecialActionCodeVisibility(true);
              }}
              style={{ marginBottom: 0 }}
            >
              <PlusOutlined /> Özel Hareket Ekle
            </Button>
          </Col>
        )} */}
      </Row>

      <TransactionProjectTypeListFilter
        activeTabKey={activeTabKey}
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs defaultActiveKey="1" onChange={handleTabChange}>
        <Tabs.TabPane tab="Proje Kodu" key="1">
          <Row>
            <Col span={24}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{
                  overflowX: "auto",
                  maxHeight: "100%",
                  width: "100%",
                }}
                columns={columns}
                onDataStateChange={dataStateChange}
                dataSource={transactionProjectTypes.data}
                loading={transactionProjectTypes.loading}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: transactionProjectTypes.total,
                  current: tableDataQueryOptions.current,
                }}
                sortable={true}
                rowKey="id"
              ></Table>
            </Col>
          </Row>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Özel Hareket Kodu" key="2">
          <Row>
            <Col span={24}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{
                  overflowX: "auto",
                  maxHeight: "100%",
                  width: "100%",
                }}
                columns={specialActionCodeColumn}
                onDataStateChange={dataStateChange}
                dataSource={transactionProjectTypes.data}
                loading={transactionProjectTypes.loading}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: transactionProjectTypes.total,
                  current: tableDataQueryOptions.current,
                }}
                sortable={true}
                rowKey="id"
              ></Table>
            </Col>
          </Row>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Masraf Merkezleri" key="3">
          <Row>
            <Col span={24}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{
                  overflowX: "auto",
                  maxHeight: "100%",
                  width: "100%",
                }}
                columns={costCenterColumn}
                onDataStateChange={dataStateChange}
                dataSource={transactionProjectTypes.data}
                loading={transactionProjectTypes.loading}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: transactionProjectTypes.total,
                  current: tableDataQueryOptions.current,
                }}
                sortable={true}
                rowKey="id"
              ></Table>
            </Col>
          </Row>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Sorumluluk Merkezleri" key="4">
          <Row>
            <Col span={24}>
              <Table
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{
                  overflowX: "auto",
                  maxHeight: "100%",
                  width: "100%",
                }}
                columns={responsibilityCenterColumn}
                onDataStateChange={dataStateChange}
                dataSource={transactionProjectTypes.data}
                loading={transactionProjectTypes.loading}
                pageable={true}
                onChange={paging}
                pagination={{
                  defaultPageSize: tableDataQueryOptions.take,
                  pageSizeOptions: ["15", "25", "50", "100"],
                  total: transactionProjectTypes.total,
                  current: tableDataQueryOptions.current,
                }}
                sortable={true}
                rowKey="id"
              ></Table>
            </Col>
          </Row>
        </Tabs.TabPane>
      </Tabs>

      <Drawer
        id="addTransactionProjectTypeDrawer"
        title="Proje Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <TransactionProjectTypeAddForm
          onSuccess={onAddTransactionProjectTypesuccess}
        />
      </Drawer>

      <Drawer
        id="addSpecialActionCodeDrawer"
        title="Özel Hareket Kodu Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormSpecialActionCodeVisibility(false)}
        visible={addFormSpecialActionCodeVisibility}
      >
        <SpecialActionCodeAddForm onSuccess={onAddSpecialActionCodeSuccess} />
      </Drawer>

      <Drawer
        id="addCostCenterDrawer"
        title="Masraf Merkezi Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormCostCenterVisibility(false)}
        visible={addFormCostCenterVisibility}
      >
        <TransactionCostCenterAddForm onSuccess={onAddCostCenterSuccess} />
      </Drawer>

      <Drawer
        id="addCostCenterDrawer"
        title="Sorumluluk Merkezi Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormResponsibilityCenterVisibility(false)}
        visible={addFormResponsibilityCenterVisibility}
      >
        <TransactionResponsibilityCenterAddForm
          onSuccess={onAddResponsibilityCenterSuccess}
        />
      </Drawer>

      <Drawer
        id="updateTransactionProjectTypeDrawer"
        title={
          activeTabKey === "1"
            ? "Proje Güncelle"
            : activeTabKey === "2"
            ? "Özel Hareket Kodu Güncelle"
            : activeTabKey === "3"
            ? "Masraf Merkezi Güncelle"
            : "Sorumluluk Merkezi Güncelle"
        }
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <TransactionProjectTypeUpdateForm
          data={updateFormData}
          onSuccess={onUpdateTransactionProjectTypesuccess}
          formTitle={
            activeTabKey === "1"
              ? "Proje"
              : activeTabKey === "2"
              ? "Özel Hareket"
              : activeTabKey == "3"
              ? "Masraf Merkezi"
              : "Sorumluluk Merkezi"
          }
        />
      </Drawer>
      {/* 
      <Drawer
        id="updateSpecialActionCodeDrawer"
        title="Özel Hareket Kodu Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormSpecialActionCodeVisibility(false)}
        visible={updateFormSpecialActionCodeVisibility}
      >
        <TransactionProjectTypeUpdateForm
          data={updateFormData}
          onSuccess={onUpdateTransactionProjectTypesuccess}
        />
      </Drawer> */}
    </>
  );
};

export default TransactionProjectTypeList;
